import { render, staticRenderFns } from "./Inquery.vue?vue&type=template&id=e610cef4&scoped=true&"
import script from "./Inquery.vue?vue&type=script&lang=js&"
export * from "./Inquery.vue?vue&type=script&lang=js&"
import style0 from "./Inquery.vue?vue&type=style&index=0&id=e610cef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e610cef4",
  null
  
)

component.options.__file = "Inquery.vue"
export default component.exports